/**
 * Claude Vision verification display helpers (frontend only).
 */

export function getVisionBadgeState(doc) {
  if (!doc?.visionCheckedAt) {
    return {
      status: 'pending',
      label: 'Verifying...',
      variant: 'neutral',
    };
  }
  if (doc.visionVerified === true) {
    return {
      status: 'verified',
      label: 'AI Verified',
      variant: 'success',
    };
  }
  return {
    status: 'unverified',
    label: 'Unverified',
    variant: 'warning',
  };
}

export function getVisionPassportIndicator(doc) {
  if (!doc?.visionCheckedAt) {
    return { label: '— Pending', color: 'var(--muted)' };
  }
  if (doc.visionVerified === true) {
    return { label: '✓ AI Verified', color: 'var(--success)' };
  }
  return { label: '⚠ Unverified', color: 'var(--warning)' };
}

export function shouldShowUnverifiedDocsBanner(documents) {
  if (!Array.isArray(documents) || documents.length === 0) return false;
  return documents.some((doc) => doc.visionVerified === false);
}

export function hasPendingVisionVerification(documents) {
  if (!Array.isArray(documents)) return false;
  return documents.some((doc) => !doc.visionCheckedAt);
}

export function shouldShowAutoDetectedExpiryNote(doc) {
  if (!doc?.visionExtractedExpiry || !doc?.expirationDate) return false;
  const extracted = new Date(doc.visionExtractedExpiry).toISOString().slice(0, 10);
  const expiration = new Date(doc.expirationDate).toISOString().slice(0, 10);
  return extracted === expiration;
}

export function formatVisionDate(value) {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
